import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  // Layout
  urlBar: {
    background: '#16213e',
    padding: '14px 32px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    borderBottom: '1px solid #0f3460',
  },
  urlRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap',
  },
  urlBarLabel: {
    color: '#94a3b8',
    fontSize: '0.78rem',
    fontWeight: 600,
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  },
  urlInput: {
    flex: 1,
    minWidth: '140px',
    padding: '9px 14px',
    background: '#0f1f38',
    border: '1px solid #2d4a6e',
    borderRadius: '8px',
    fontSize: '0.88rem',
    fontFamily: "'SF Mono', 'Fira Code', monospace",
    '& input': {
      color: '#e2e8f0',
      padding: '6px 8px',
    },
    '& input::placeholder': {
      color: '#4a6080',
      opacity: 1,
    },
  },
  container: {
    padding: '20px 32px',
  },
  // Stats bar
  statsBar: {
    display: 'flex',
    gap: '14px',
    padding: '12px 32px',
    background: '#fff',
    borderBottom: '1px solid #e5e7eb',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  statPill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '5px 14px',
    borderRadius: '20px',
    fontSize: '0.78rem',
    fontWeight: 600,
    background: '#eff6ff',
    color: '#1d4ed8',
    border: '1px solid #bfdbfe',
  },
  statPillGreen: {
    background: '#f0fdf4',
    color: '#166534',
    borderColor: '#bbf7d0',
  },
  statPillAmber: {
    background: '#fffbeb',
    color: '#92400e',
    borderColor: '#fde68a',
  },
  statPillStrong: {
    fontWeight: 800,
  },
  // Filter bar
  filterBar: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: '12px 18px',
    borderBottom: '1px solid #f1f5f9',
  },
  filterInput: {
    minWidth: '260px',
    padding: '3px 14px',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    fontSize: '0.85rem',
    background: '#fff',
    '& input': {
      padding: '6px 8px',
    },
  },
  filterSelect: {
    padding: '3px 14px',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    fontSize: '0.85rem',
    background: '#fff',
    color: '#1e293b',
    cursor: 'pointer',
  },
  selectPaper: {
    maxHeight: '300px',
    marginTop: '4px',
  },
  filterRight: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    marginLeft: 'auto',
    flexWrap: 'wrap',
  },
  resultCount: {
    fontSize: '0.78rem',
    color: '#64748b',
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  // Card
  card: {
    background: '#fff',
    borderRadius: '12px',
    boxShadow: '0 1px 6px rgba(0,0,0,0.07)',
    overflow: 'hidden',
  },
  tableWrap: {
    overflowX: 'auto',
  },
  // Buttons
  submitBtn: {
    marginLeft: 'auto',
    padding: '9px 22px',
    background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
    color: '#fff',
    borderRadius: '8px',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      opacity: 0.9,
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },
  exportBtn: {
    padding: '8px 16px',
    background: 'linear-gradient(135deg, #065f46, #059669)',
    color: '#fff',
    borderRadius: '8px',
    fontSize: '0.82rem',
    fontWeight: 700,
    '&:hover': {
      opacity: 0.88,
    },
  },
  exportPerSiteBtn: {
    padding: '8px 16px',
    background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
    color: '#fff',
    borderRadius: '8px',
    fontSize: '0.82rem',
    fontWeight: 700,
    '&:hover': {
      opacity: 0.88,
    },
  },
  // Table
  siteIdsTable: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '0.8rem',
    '& thead th': {
      background: '#335977',
      padding: '11px 14px',
      textAlign: 'left',
      fontSize: '0.72rem',
      fontWeight: 700,
      color: '#FFE784',
      letterSpacing: '0.6px',
      textTransform: 'uppercase',
      borderBottom: '2px solid #e5e7eb',
      whiteSpace: 'nowrap',
    },
    '& tbody tr': {
      borderBottom: '1px solid #f1f5f9',
      transition: 'background 0.1s',
      '&:hover': {
        background: '#f8fafc',
      },
    },
    '& tbody td': {
      padding: '7px 10px',
      verticalAlign: 'middle',
    },
  },
  // TableData required styles
  tableHeader: {
    fontWeight: 700,
    backgroundColor: '#335977',
    whiteSpace: 'nowrap',
  },
  isBold: {
    fontWeight: 700,
    color: '#FFFFFF',
  },
  sortContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '4px',
    cursor: 'pointer',
  },
  sortUp: {
    marginBottom: '-8px',
  },
  sortDown: {
    marginTop: '-4px',
  },
  active: {
    color: '#FFE784',
  },
  inactive: {
    color: '#b0bac6',
  },
  emptyTableContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '150px',
    flexDirection: 'column',
  },
  titleWrapper: {
    whiteSpace: 'nowrap',
    fontSize: '0.8rem',
  },
  // Pagination styles
  paginationBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 18px',
    borderTop: '1px solid #e5e7eb',
    background: '#fafbfc',
    fontSize: '0.78rem',
    flexWrap: 'wrap',
    gap: '8px',
  },
  paginationLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  paginationRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  paginationLabel: {
    color: '#64748b',
    fontSize: '0.78rem',
  },
  paginationSelect: {
    padding: '2px 8px',
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    fontSize: '0.78rem',
    background: '#fff',
    cursor: 'pointer',
  },
  paginationInfo: {
    color: '#334155',
    fontSize: '0.78rem',
    fontWeight: 600,
  },
  paginationArrow: {
    minWidth: '28px',
    width: '28px',
    height: '28px',
    padding: 0,
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    background: '#fff',
    cursor: 'pointer',
    fontSize: '0.82rem',
    color: '#475569',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      background: '#f1f5f9',
    },
    '&:disabled': {
      opacity: 0.4,
      cursor: 'not-allowed',
    },
  },
  paginationPageBtn: {
    minWidth: '28px',
    width: '28px',
    height: '28px',
    padding: 0,
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    background: '#fff',
    cursor: 'pointer',
    fontSize: '0.78rem',
    color: '#475569',
    '&:hover': {
      background: '#f1f5f9',
    },
  },
  paginationPageBtnActive: {
    background: '#2563eb',
    color: '#fff',
    borderColor: '#2563eb',
    '&:hover': {
      background: '#1d4ed8',
    },
  },
  paginationEllipsis: {
    color: '#94a3b8',
    fontSize: '0.78rem',
    padding: '0 4px',
  },
  // Program cell
  programName: {
    fontWeight: 600,
    fontSize: '0.82rem',
    color: '#1e293b',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
  },
  programKey: {
    fontSize: '0.65rem',
    color: '#94a3b8',
    fontFamily: "'SF Mono', 'Fira Code', monospace",
    marginTop: '1px',
  },
  // Account badge
  accountBadge: {
    display: 'inline-block',
    padding: '2px 10px',
    borderRadius: '12px',
    fontSize: '0.75rem',
    fontWeight: 600,
    background: '#eff6ff',
    color: '#1d4ed8',
    border: '1px solid #bfdbfe',
    whiteSpace: 'nowrap',
  },
  // Date badge
  dateBadge: {
    display: 'inline-block',
    padding: '2px 10px',
    borderRadius: '12px',
    fontSize: '0.75rem',
    fontWeight: 600,
    background: '#fffbeb',
    color: '#92400e',
    border: '1px solid #fde68a',
  },
  // Count badges
  countBadge: {
    display: 'inline-block',
    padding: '2px 10px',
    borderRadius: '12px',
    fontSize: '0.78rem',
    fontWeight: 700,
    background: '#f0fdf4',
    color: '#166534',
    border: '1px solid #bbf7d0',
  },
  countZero: {
    background: '#f9fafb',
    color: '#9ca3af',
    borderColor: '#e5e7eb',
  },
  noBatteryBadge: {
    display: 'inline-block',
    padding: '2px 10px',
    borderRadius: '12px',
    fontSize: '0.78rem',
    fontWeight: 700,
    background: '#fffbeb',
    color: '#92400e',
    border: '1px solid #fde68a',
  },
  noBatteryNull: {
    color: '#d1d5db',
    fontStyle: 'italic',
    fontSize: '0.8rem',
  },
  // Sites textarea
  sitesTextarea: {
    width: '100%',
    minWidth: '260px',
    maxWidth: '440px',
    height: '72px',
    padding: '6px 8px',
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    fontSize: '0.72rem',
    fontFamily: "'SF Mono', 'Fira Code', monospace",
    color: '#334155',
    background: '#f8fafc',
    resize: 'vertical',
    outline: 'none',
  },
  sitesTextareaEmpty: {
    height: '36px',
    fontStyle: 'italic',
    color: '#9ca3af',
  },
  noBatterySitesTextarea: {
    width: '100%',
    minWidth: '200px',
    maxWidth: '360px',
    height: '72px',
    padding: '6px 8px',
    border: '1px solid #fde68a',
    borderRadius: '6px',
    fontSize: '0.72rem',
    fontFamily: "'SF Mono', 'Fira Code', monospace",
    color: '#92400e',
    background: '#fffbeb',
    resize: 'vertical',
    outline: 'none',
  },
  noBatterySitesEmpty: {
    height: '36px',
    fontStyle: 'italic',
    color: '#9ca3af',
    background: '#f8fafc',
    borderColor: '#e2e8f0',
  },
  // Number cells right-aligned
  numCell: {
    textAlign: 'right',
  },
  // No-battery header columns amber background
  noBatteryHeader: {
    background: '#92400e',
  },
  // Grand total row
  grandTotalCell: {
    background: '#fefce8',
    borderTop: '2px solid #fde68a',
    fontWeight: 700,
    color: '#92400e',
    fontSize: '0.78rem',
    whiteSpace: 'nowrap',
  },
  grandTotalLabel: {
    textAlign: 'right',
    background: '#fefce8',
    borderTop: '2px solid #fde68a',
    fontWeight: 700,
    color: '#92400e',
    fontSize: '0.82rem',
  },
  // Index cell
  indexCell: {
    color: '#9ca3af',
    fontSize: '0.75rem',
    textAlign: 'right',
    width: '36px',
  },
}))

export { useStyles }
